export enum PlatformTransportationFragments {
    Driver = 'Driver',
    Trailer = 'Trailer',
    Vehicle = 'Vehicle',
}
